import { useGetFeatureIndicator } from '~/api/service/feature.service'
import { IFeaturedMenuKey } from '~/types/featured.type'

/** @description
 * 부분별 키에 따라 해당 부분의 하이라이트 상태(new, hot 등)를 가져옵니다.
 */
export const useFeatureIndicator = (menuKey: IFeaturedMenuKey) => {
  // const { data } = useGetFeatureIndicator()
  // const allFeaturedMap = computed(() => data.value?.featuredMap)
  const allFeaturedMap = computed(() => new Map())

  const partFeaturedMap = computed(() => allFeaturedMap.value?.get(menuKey))

  return { allFeaturedMap, partFeaturedMap }
}